/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCatalog200ResponseModifiersInner } from './GetCatalog200ResponseModifiersInner';
import {
    GetCatalog200ResponseModifiersInnerFromJSON,
    GetCatalog200ResponseModifiersInnerFromJSONTyped,
    GetCatalog200ResponseModifiersInnerToJSON,
    GetCatalog200ResponseModifiersInnerToJSONTyped,
} from './GetCatalog200ResponseModifiersInner';
import type { GetCatalog200ResponseCategoriesInner } from './GetCatalog200ResponseCategoriesInner';
import {
    GetCatalog200ResponseCategoriesInnerFromJSON,
    GetCatalog200ResponseCategoriesInnerFromJSONTyped,
    GetCatalog200ResponseCategoriesInnerToJSON,
    GetCatalog200ResponseCategoriesInnerToJSONTyped,
} from './GetCatalog200ResponseCategoriesInner';

/**
 * 
 * @export
 * @interface GetCatalog200Response
 */
export interface GetCatalog200Response {
    /**
     * 
     * @type {string}
     * @memberof GetCatalog200Response
     */
    catalogName: string;
    /**
     * 
     * @type {Array<GetCatalog200ResponseCategoriesInner>}
     * @memberof GetCatalog200Response
     */
    categories: Array<GetCatalog200ResponseCategoriesInner>;
    /**
     * 
     * @type {Array<GetCatalog200ResponseModifiersInner>}
     * @memberof GetCatalog200Response
     */
    modifiers: Array<GetCatalog200ResponseModifiersInner>;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetCatalog200Response
     */
    modifierGroups: Array<any>;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetCatalog200Response
     */
    combos: Array<any>;
}

/**
 * Check if a given object implements the GetCatalog200Response interface.
 */
export function instanceOfGetCatalog200Response(value: object): value is GetCatalog200Response {
    if (!('catalogName' in value) || value['catalogName'] === undefined) return false;
    if (!('categories' in value) || value['categories'] === undefined) return false;
    if (!('modifiers' in value) || value['modifiers'] === undefined) return false;
    if (!('modifierGroups' in value) || value['modifierGroups'] === undefined) return false;
    if (!('combos' in value) || value['combos'] === undefined) return false;
    return true;
}

export function GetCatalog200ResponseFromJSON(json: any): GetCatalog200Response {
    return GetCatalog200ResponseFromJSONTyped(json, false);
}

export function GetCatalog200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCatalog200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'catalogName': json['catalogName'],
        'categories': ((json['categories'] as Array<any>).map(GetCatalog200ResponseCategoriesInnerFromJSON)),
        'modifiers': ((json['modifiers'] as Array<any>).map(GetCatalog200ResponseModifiersInnerFromJSON)),
        'modifierGroups': json['modifierGroups'],
        'combos': json['combos'],
    };
}

export function GetCatalog200ResponseToJSON(json: any): GetCatalog200Response {
    return GetCatalog200ResponseToJSONTyped(json, false);
}

export function GetCatalog200ResponseToJSONTyped(value?: GetCatalog200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'catalogName': value['catalogName'],
        'categories': ((value['categories'] as Array<any>).map(GetCatalog200ResponseCategoriesInnerToJSON)),
        'modifiers': ((value['modifiers'] as Array<any>).map(GetCatalog200ResponseModifiersInnerToJSON)),
        'modifierGroups': value['modifierGroups'],
        'combos': value['combos'],
    };
}

